import { SignalRLocationMessage } from '../interfaces/signalR-location.interface';
import { LocationsService } from '../services/locations.service';

export function refreshLocationsHandler(
  message: SignalRLocationMessage,
  locationService: LocationsService,
): void {
  console.log('RefreshLocations event received with message:', message);

  locationService.refreshLocation(message);
}
